import { useMutation } from '@vue/apollo-composable';
import { BULK_UPDATE_CURRICULUM, CLONE_MODULES_WITH_COURSES } from '@/graphql/mutations/moduleCurriculum';

export function useModuleCurriculumMutations() {
  const { mutate: bulkUpdateMutate } = useMutation(BULK_UPDATE_CURRICULUM);
  const { mutate: cloneModules, loading: cloning } = useMutation(CLONE_MODULES_WITH_COURSES, { refetchQueries: ['ListProgrammeModules'] });
  return { bulkUpdateMutate, cloneModules, cloning };
}
